<template>
    <app-form-group
        :class="{'loading-opacity disabled': loading}"
        :page="page"
        :type="type"
        v-model="model"
        v-bind="propsFor()"
        v-on="$listeners"
        :list="arrays"
        :form-group-class="formGroupClass"
        @input="$emit('input', $event)"
        :id="id || $vnode.data.model.expression"
        :recommendation="recommendation"
    >
        <template slot="suggestion" v-if="chooseAll">
            <app-input
                type="single-checkbox"
                v-model="isAll"
                :listValueField="$t('choose_all')"
                labelClass="mt-2"
                :id="id ? `${id}-choose` : `${$vnode.data.model.expression}-choose`"
            />
        </template>
    </app-form-group>
</template>

<script>
import _ from "lodash";
import {kebabCase} from "../../../common/Helper/Support/TextHelper";
import {axiosGet} from "../../../common/Helper/AxiosHelper";
import {addChooseInSelectArray} from "../../../common/Helper/Support/FormHelper";

export default {
    name : "AppFromGroupSelectable",
    props: {
        page          : {
            required: false,
            default : 'modal'
        },
        type          : {
            required: false,
            default : 'search-select'
        },
        value         : {
            required: true,
            default : function () {
                return '';
            }
        },
        chooseLabel   : {
            default: false
        },
        fetchUrl      : {
            type    : String,
            required: false,
        },
        formGroupClass: {
            type: String
        },
        chooseAll     : {
            type   : Boolean,
            default: false
        },
        recommendation: {
            type   : String,
            default: ''
        },
        options       : {
            type   : Array,
            default: function () {
                return [];
            }
        },
        labelGenerator: {
            type   : Function,
            default: null
        },
        id: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            model  : [],
            arrays : [],
            loading: true,
            isAll  : false
        }
    },
    methods: {
        propsFor() {
            let props  = this.$attrs;
            const cTor = this.$options.components['app-input']
            if (cTor) {
                let keys = Object.keys(cTor.options.props)
                return _.pick(props, keys.map(key => {
                    return kebabCase(key)
                }))
            }
        },
        getData() {
            this.loading = true;
            if (this.options.length) {
                this.arrays = this.applyChooseLabel(this.formatList(this.options));
                this.loading = false;
                return;
            }

            axiosGet(this.fetchUrl).then(response => {
                if (this.$attrs['list-value-id']) {
                    for (const i in response.data) {
                        response.data[i].id = response.data[i][this.$attrs['list-value-id']] || 0
                    }
                }
                const formattedData = this.formatList(response.data);
                this.arrays = this.applyChooseLabel(formattedData);
            }).finally(() => {
                this.loading = false;
            })
        },
        formatList(list = []) {
            if (!this.labelGenerator || !Array.isArray(list)) {
                return list;
            }
            const valueField = this.$attrs['list-value-field'] || 'name';
            return list.map(item => ({
                ...item,
                [valueField]: this.labelGenerator(item) || ''
            }));
        },
        applyChooseLabel(list = []) {
            if (!this.chooseLabel) {
                return list;
            }
            const valueField = this.$attrs['list-value-field'] || 'name';
            return addChooseInSelectArray(list, valueField, this.chooseLabel);
        },
        normalizeValue(value) {
            if (value === undefined || value === null) {
                return '';
            }
            return value;
        }
    },
    watch  : {
        value         : {
            handler  : function (value) {
                this.model = this.normalizeValue(value);
            },
            immediate: true
        },
        fetchUrl      : {
            handler  : function (newVal) {
                if (newVal) {
                    this.getData();
                }
            },
            immediate: true
        },
        options       : {
            handler  : function (newOptions) {
                if (newOptions && newOptions.length > 0) {
                    this.arrays = this.applyChooseLabel(this.formatList(newOptions));
                    this.loading = false;
                } else {
                    this.arrays = [];
                    this.loading = false;
                }
            },
            immediate: true,
            deep     : true
        },
        'model.length': function (length) {
            if (!length) {
                this.isAll = false;
            }
        },
        isAll         : function (isAll) {
            if (isAll) {
                this.model = this.collection(this.arrays).pluck();
                this.$emit('input', this.model);
            }
        }
    }
}
</script>
